import React from 'react';
import './AdminTableAnswersForType4.scss';
//import {printQuizesCategory} from "../../../../../utils/helps.js";
import TableAnswersForType4 from './TableAnswersForType4/TableAnswersForType4';
import { openAddInputFormsForAnswersType4  } from '../../../adminSlice';

export default class AdminTableAnswersForType4 extends React.Component {
    constructor(props) {
        super(props);
        
        this.onAdd = this.onAdd.bind(this);
    }

    onAdd() {
        const { dispatch } = this.props;
    
        dispatch(openAddInputFormsForAnswersType4());
    
    }
    render() {
        let style;
       // console.log(this.props.adminState.dataSubCategoryId.length);
        if (this.props.adminState.selectedQuestion) {
          
                style = ''
            } else {
                style = 'disabled'
            }

        const { dispatch} = this.props;
        return (
            
            <div className="AdminTableAnswersForType4">
                   <p className='tableName'>Список боксов {this.props.adminState.selectedQuestion} вопроса </p>

                   <TableAnswersForType4 
                   dispatch={dispatch}
                   data={this.props.adminState.dataAnswersIdForType4}
                   />

                   <button className='addButton' onClick={this.onAdd} disabled={style}>{/*<i className="fas fa-plus"></i>*/}</button> 

                    


                
            </div>
        )
    }
}